export default __webpack_public_path__ + "static/media/PAFI_LKTT 2024.c7fbc0e6.pdf";